<template>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <tabs type="boxed">
            <tab-pane label="Логин и пароль">
              <label class="label">E-mail</label>
              <p class="control">
                <input v-model="user.username" class="input" type="email" placeholder="Введите e-mail">
              </p>
              <label class="label">Пароль</label>
              <p class="control">
                <input v-model="user.password" class="input" type="password" placeholder="Введите пароль">
              </p>
              <button v-if="canUpdate(permissionKey) || loggedId==user.id" class="button is-primary" v-on:click="save">
              <span class="icon">
                <i class="fa fa-floppy-o"></i>
              </span>
                <span>Сохранить</span>
              </button>
              <button class="button is-light" v-on:click="cancel">
              <span class="icon">
                <i class="fa fa-times-circle"></i>
              </span>
                <span>Закрыть</span>
              </button>
            </tab-pane>
            <tab-pane label="Профиль пользователя">
              <label class="label">E-mail</label>
              <p class="control">
                <input v-model="profile.username" class="input" type="text" v-bind:disabled="true">
              </p>
              <label class="label">Идентификатор пользователя</label>
              <p class="control">
                <input v-model="profile.id" class="input" type="text" v-bind:readonly="true">
              </p>
              <label class="label">Клиент</label>
              <p class="control">
                <span class="select">
                <select v-model="profile.client" :disabled="!canUpdateUserTypeAndState(permissionKey)">
                  <option v-for="client in clients" v-bind:value="client.id">
                    {{client.name}}
                  </option>
                </select>
              </span>
              </p>
              <label class="label">Тип</label>
              <p class="control">
              <span class="select">
                <select v-model="profile.roleId" :disabled="!canUpdateUserTypeAndState(permissionKey)">
                  <option v-if="loggedRole <= 1" value="1">СуперАдминистратор</option>
                  <option v-if="loggedRole <= 2"value="2">Администратор</option>
                  <option v-if="loggedRole <= 4"value="4">Партнер</option>
                  <option v-if="loggedRole <= 8"value="8">Реферер</option>
                  <option v-if="loggedRole <= 16"value="16">Клиент</option>
                </select>
              </span>
              </p>
              <label class="label">Статус</label>
              <p class="control">
              <span class="select">
                <select v-model="profile.state" :disabled="!canUpdateUserTypeAndState(permissionKey)">
                  <option value="FILL_PROFILE">Заполните личную карточку</option>
                  <option value="SIGN_CONTRACT">Ожидаем подписания договора</option>
                  <option value="REFILL_BALANCE">Нужно пополнить баланс</option>
                  <option value="ACTIVE">Активен</option>
                </select>
              </span>
              </p>
              <label class="label">ФИО</label>
              <p class="control">
                <input v-model="profile.fullname" class="input" type="text">
              </p>
              <label class="label">Часовой пояс (UTC)</label>
              <p class="control">
              <span class="select">
                <select v-model="profile.timeZone">
                  <option>0</option>
                  <option>+1</option>
                  <option>+2</option>
                  <option>+3</option>
                  <option>+4</option>
                  <option>+5</option>
                  <option>+6</option>
                  <option>+7</option>
                  <option>+8</option>
                  <option>+9</option>
                  <option>+10</option>
                  <option>+11</option>
                  <option>+12</option>
                </select>
              </span>
              </p>
              <label class="label">Телефон</label>
              <p class="control">
                <input v-model="profile.phone" class="input" type="text">
              </p>
              <label class="label">ИНН</label>
              <p class="control">
                <input v-model="profile.INN" class="input" type="text">
              </p>
              <label class="label">Адрес</label>
              <p class="control">
                <input v-model="profile.address" class="input" type="text">
              </p>
              <label class="label">Паспорт</label>
              <p class="control">
                <input v-model="profile.passport" class="input" type="text">
              </p>
              <label class="label">Вид деятельности</label>
              <p class="control">
                <input v-model="profile.businessType" class="input" type="text">
              </p>
              <label class="label">Менеджер</label>
              <p class="control">
                <input v-model="profile.manager" class="input" type="text">
              </p>
              <label class="label">Тариф</label>
              <p class="control">
                <input v-model="profile.tariff" class="input" type="text">
              </p>
              <p class="control">
                <input v-if="canUpdate(permissionKey) || loggedId==user.id" class="button is-info" type="button" id="uploadFile" value="Загрузить скан договора (pdf, jpg, png; до 10 Мб)" onclick="document.getElementById('uploadContract').click();">
                <input style="display:none;" @input="uploadContract('uploadContract')" :id="`uploadContract`" name="load-contract" type="file" accept=".jpg,.png,.pdf">
                <a  v-if="profile.contractName!=''" :href="'/api/profiles/contract?userId=' + user.id"  tag="button">
                  <button class="button is-info">
                  <span class="icon">
                    <i class="fa fa-download"></i>
                  </span>
                    <span>Просмотр договора</span>
                  </button>
                </a>
              </p>
              <button v-if="canUpdate(permissionKey) || loggedId==user.id" class="button is-primary" v-on:click="saveProfile">
              <span class="icon">
                <i class="fa fa-floppy-o"></i>
              </span>
                <span>Сохранить</span>
              </button>
              <button class="button is-light" v-on:click="cancel">
              <span class="icon">
                <i class="fa fa-times-circle"></i>
              </span>
                <span>Закрыть</span>
              </button>
            </tab-pane>
            <tab-pane label="Лицевой счет">
              <label class="label">E-mail</label>
              <p class="control">
                <input v-model="profile.username" class="input" type="text" v-bind:disabled="true">
              </p>
              <div class="table-responsive">
                <table class="table is-bordered is-striped is-narrow">
                  <thead>
                  <tr>
                    <th @click="sort('date')">Дата{{sortIcon('date')}}</th>
                    <th @click="sort('sumPay')">Сумма пополнено{{sortIcon('sumPay')}}</th>
                    <th @click="sort('sumConsume')">Сумма израсходовано{{sortIcon('sumConsume')}}</th>
                    <th @click="sort('author')">Автор{{sortIcon('author')}}</th>
                    <th>Действие</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="billing in sortedBillings">
                    <td>
                      {{billing.date}}
                    </td>
                    <td>
                      {{billing.sumPay}}
                    </td>
                    <td>
                      {{billing.sumConsume}}
                    </td>
                    <td>
                      {{billing.author}}
                    </td>
                    <td>
                    </td>
                  </tr>
                  <tr v-if="canUpdateUserPayment(permissionKey)">
                    <td>
                      <!--<input v-model="newbilling.date" class="input" type="date" placeholder="Введите дату">-->
                      <datepicker v-model="newbilling.date" placeholder="Введите дату" :inputClass="{ test: true }" :config="{ wrap: true, dateFormat: 'd.m.Y', locale: l10n }" readonly>
                        <a class="button" data-toggle><i class="fa fa-calendar"></i></a>
                        <a class="button" data-clear><i class="fa fa-close"></i></a>
                      </datepicker>
                    </td>
                    <td><input v-model="newbilling.sumPay" class="input" type="" placeholder="Введите сумму оплаты"></td>
                    <td></td>
                    <td>
                    <td>
                      <button class="button is-success" v-on:click="addPayment">
                    <span class="icon">
                      <i class="fa fa-plus-circle"></i>
                    </span>
                        <span>Добавить оплату</span>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <th>ИТОГО</th>
                    <th>{{sumPay}}</th>
                    <th>{{sumConsume}}</th>
                    <th>ОСТАТОК</th>
                    <th>{{balance}}</th>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div id="page-navigation">
                <ul class="pagination">
                  <li class="pagination-item">
                    <button
                      type="button"
                      @click="onClickFirstPage"
                      :disabled="isInFirstPage"
                      aria-label="Go to first page"
                    >
                      Первая
                    </button>
                  </li>
                  <li class="pagination-item">
                    <button
                      type="button"
                      @click="onClickPreviousPage"
                      :disabled="isInFirstPage"
                      aria-label="Go to previous page"
                    >
                      Предыдущая
                    </button>
                  </li>
                  <li v-for="page in pages" class="pagination-item">
                    <button
                      type="button"
                      @click="onClickPage(page.name)"
                      :disabled="page.isDisabled"
                      :class="{ activepage: isPageActive(page.name) }"
                      :aria-label="`Go to page number ${page.name}`"
                    >
                      {{ page.name }}
                    </button>
                  </li>
                  <li class="pagination-item">
                    <button
                      type="button"
                      @click="onClickNextPage"
                      :disabled="isInLastPage"
                      aria-label="Go to next page"
                    >
                      Следующая
                    </button>
                  </li>
                  <li class="pagination-item">
                    <button
                      type="button"
                      @click="onClickLastPage"
                      :disabled="isInLastPage"
                      aria-label="Go to last page"
                    >
                      Последняя
                    </button>
                  </li>
                </ul>
              </div>
              <br>
              <div v-if="loggedId==user.id" class="control is-grouped">
                <p class="control">
                  <button class="button is-primary" v-on:click="makePayment">
                <span class="icon">
                  <i class="fa fa-money"></i>
                </span>
                    <span>Оплатить на сумму</span>
                  </button>
                </p>
                <p class="control is-expanded">
                  <input v-model="sumPayment" class="input" type="" placeholder="Введите сумму оплаты">
                </p>
              </div>
              <p class="control">
                <button class="button is-light" v-on:click="cancel">
                <span class="icon">
                  <i class="fa fa-times-circle"></i>
                </span>
                  <span>Закрыть</span>
                </button>
              </p>
            </tab-pane>
          </tabs>
        </article>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import Notification from 'vue-bulma-notification'
import Cleave from 'vue-cleave'
import { Tabs, TabPane } from 'vue-bulma-tabs'
import Datepicker from 'vue-bulma-datepicker'
import CheckToken from '../authentication/CheckToken'
import CheckPermission from '../authentication/CheckPermission'

Vue.mixin(CheckToken)
Vue.mixin(CheckPermission)

const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}


const USERS_API = '/api/users'
const BILLING_API = '/api/billing'
const PROFILES_API = '/api/profiles'
const PAYMENTS_API = '/api/payments'
const CLIENTS_API = '/api/clients'

export default {
  props: ['id'],
  components: {
    Cleave,
    Datepicker,
    Notification,
    Tabs,
    TabPane
  },
  data () {
    return {
      user: {},
      profile: {},
      clients: {},
      userid: 0,
      billings: [],
      sortedBillings: [],
      currentPage: 1,
      perPage: 10,
      maxVisibleButtons: 10,
      currentSort: 'date',
      currentSortDir: 'asc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      newbilling: {},
      balance: 0,
      sumPay: 0,
      sumConsume: 0,
      sumPayment: 0,
      permissionKey: 'user',
      regSum: /^[-]?[0-9]+[.]?[0-9]{0,2}$/,
      regEmail: /^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,6}$/
    }
  },
  created: function () {
    console.log('role ' + this.loggedRole)
    this.checkToken()
    this.loadClients()
    this.handleUser()
  },
  computed: {
    ...mapGetters([
      'authenticationToken',
      'loggedUser',
      'loggedRole',
      'loggedId'
    ]),
    l10n () {
      return {
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
          longhand: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']
        },
        months: {
          shorthand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
          longhand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
        }
      }
    },
    totalPages() {
      return Math.max(Math.ceil(this.billings.length / this.perPage), 1)
    },
    startPage() {
      if (this.currentPage === 1) {
        return 1
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1)
      }

      return this.currentPage - 1
    },
    endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages)
    },
    pages() {
      const range = []
      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        })
      }
      return range
    },
    isInFirstPage() {
      return this.currentPage === 1
    },
    isInLastPage() {
      return this.currentPage === this.totalPages
    }
  },
  methods: {
    prepareSecurityHeader() {
      console.log(this.authenticationToken)
      return {
        Authorization: `Bearer ${this.authenticationToken}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      }
    },
    save () {
      if (this.user.id === undefined) {
        this.saveNew()
      } else {
        this.update()
      }
    },
    saveNew () {
      if (this.user.username != '') {
        if (this.regEmail.test(this.user.username)) {
          console.log('saving new user: ' + JSON.stringify(this.user))
          this.$http.post(USERS_API, this.user, {headers: this.prepareSecurityHeader()})
            .then((response) => {
              if (response.data != '') {
                this.user = response.data
                this.openNotificationWithType('info', 'Логин и пароль сохранены.')
                // this.$router.push('/users/')
                this.loadProfile()
                this.loadBilling()
              } else {
                console.log('Already exist')
                this.openNotificationWithType('danger', 'Такой пользователь уже существует')
              }
            }).catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка регистрации пользователя')
          })
        } else {
          this.openNotificationWithType('danger', 'Необходимо ввести корректный адрес электронной почты')
        }
      } else {
        this.openNotificationWithType('danger', 'Необходимо ввести адрес электронной почты')
      }
    },
    update () {
      if (this.user.username != '') {
        if (this.regEmail.test(this.user.username)) {
          console.log('updating user: ' + JSON.stringify(this.user))
          this.$http.put(USERS_API, this.user, {headers: this.prepareSecurityHeader()})
            .then((response) => {
              console.log(response.data)
              this.openNotificationWithType('info', 'Логин и пароль сохранены.')
              // this.$router.push('/users/')
            }).catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка регистрации пользователя')
          })
        } else {
          this.openNotificationWithType('danger', 'Необходимо ввести корректный адрес электронной почты')
        }
      } else {
        this.openNotificationWithType('danger', 'Необходимо ввести адрес электронной почты')
      }
    },
    saveProfile () {
      if (this.user.id) {
        if (this.profile.id === undefined) {
          this.saveNewProfile()
        } else {
          this.updateProfile()
        }
      } else {
        this.openNotificationWithType('danger', 'Сначала необходимо сохранить логин и пароль')
      }
    },
    saveNewProfile () {
//      if (this.user.username != '') {
//        if (this.reg.test(this.user.username)) {
      console.log('saving new profile: ' + JSON.stringify(this.profile))
      this.$http.post(PROFILES_API, this.profile, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          if (response.data != '') {
            console.log(response.data)
            this.isSaved = true
            this.profile = response.data
            this.openNotificationWithType('info', 'Профиль пользователя сохранен.')
//                this.$router.push('/users/')
          } else {
            console.log('Already exist')
            this.openNotificationWithType('danger', 'Такой профиль уже существует.')
          }
        }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка сохранения данных')
      })
//        } else {
//          errorMessage = 'Необходимо ввести корректный адрес электронной почты'
//        }
//      } else {
//        errorMessage = 'Необходимо ввести адрес электронной почты'
//      }
    },
    updateProfile () {
//      if (this.user.username != '') {
//        if (this.reg.test(this.user.username)) {
      console.log('updating profile: ' + JSON.stringify(this.profile))
      this.$http.put(PROFILES_API, this.profile, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.isSaved = true
          console.log(response.data)
          this.openNotificationWithType('info', 'Профиль пользователя сохранен.')
//              this.$router.push('/users/')
        }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка сохранения данных')
      })
//        } else {
//          errorMessage = 'Необходимо ввести корректный адрес электронной почты'
//        }
//      } else {
//        errorMessage = 'Необходимо ввести адрес электронной почты'
//      }
    },
    loadClients () {
      this.$http.get(CLIENTS_API + '/getClients/' + this.loggedId, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.clients = response.data
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки клиентов пользователя. ')
        })
    },
    handleUser () {
      if (this.$props.id != 'new' && this.$props.id) {
        console.log('loading user: ' + this.name)
        this.loadUser()
      } else {
        console.log('creating new user')
        return {}
      }
    },
    loadUser () {
      this.$http({
        url: USERS_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        this.userid = response.data.id
        this.user = response.data
        // this.getBalance()
        this.handleProfile()
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка загрузки пользователя. ')
      })
    },
    loadBilling () {
      this.$http({
        url: BILLING_API + '/' + this.profile.client,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        console.log('opening campaign ' + response.data.id)
        this.billings = response.data
        this.sortedBillings = this.sortedBilling()
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка загрузки биллинга. ')
      })
    },
    cancel () {
      this.$router.push('/users/')
    },
    handleProfile () {
      if (this.$props.id) {
        console.log('loading profile: ' + this.profile.username)
        this.loadProfile()
      } else {
        console.log('creating new profile')
        this.notSaved()
        return {}
      }
    },
    loadProfile () {
      this.$http({
        url: PROFILES_API + '/' + this.user.id,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        this.profile = response.data
        this.isSaved = true
        this.handleBilling()
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка загрузки профиля пользователя. ')
      })
    },
    handleBilling () {
      if (!this.$props.id) {
        // this.$router.push('/users')
      } else {
        console.log('loading billing: ' + this.name)
        this.loadBilling()
        this.getBalance()
        this.getSumPayment()
        this.getSumConsume()
      }
    },
    uploadContract(inputId) {
      if (this.user.id) {
        const input = document.querySelector(`#${inputId}`)
        if (input.files && input.files[0]) {
          if (!this.isSaved) {
            this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить профиль')
          } else {
            if (input.files[0].size > 10 * 1024 * 1024) {
              this.openNotificationWithType('danger', 'Слишком большой файл (> 10 Мб)')
            } else {
              this.handleUploadContractRequest(input.files[0])
            }
          }
        }
      } else {
        this.openNotificationWithType('danger', 'Сначала необходимо сохранить логин и пароль')
      }
    },
    handleUploadContractRequest (contractFile) {
      this.$http.post(PROFILES_API + '/' + 'loadContract', this.prepareMultipartFile(contractFile, this.user.id), this.prepareSecurityHeader())
        .then(response => {
          console.log(response)
          if (response.status == 200) {
            this.openNotificationWithType('info', 'Файл загружен.')
            // this.loadTasksCount()
            this.loadProfile()
          } else {
            this.openNotificationWithType('danger', 'Ошибка загрузки файла')
            // this.loadTasksCount()
          }
        })
        .catch(error => {
          this.openNotificationWithType('danger', 'Ошибка загрузки файла')
          // this.loadTasksCount()
          console.log(error)
        })
      // this.loadTasksCountPerformed()
    },
    prepareMultipartFile (contractFile, userId) {
      const contractFormData = new FormData()
      contractFormData.append('file', contractFile)
      contractFormData.append('id', userId)
      return contractFormData
    },
    addPayment () {
      if (this.profile.client) {
        if (this.newbilling.date) {
          if (this.regSum.test(this.newbilling.sumPay)) {
            if (this.newbilling.sumPay != 0) {
              this.newbilling.client = this.profile.client
              this.newbilling.sumConsume = 0
              this.$http.post(BILLING_API, this.newbilling, {headers: this.prepareSecurityHeader()})
                .then((response) => {
                  this.openNotificationWithType('success', 'Оплата добавлена')
                  this.billings = response.data
                  this.sortedBillings = this.sortedBilling()
                  this.getBalance()
                  this.getSumPayment()
                  this.getSumConsume()
                  this.newbilling.sumPay = ''
                })
                .catch((error) => {
                  console.log(error)
                  this.openNotificationWithType('danger', 'Ошибка добавления оплаты пользователя. ')
                })
            } else {
              this.openNotificationWithType('danger', 'Укажите ненулевую сумму')
            }
          } else {
            this.openNotificationWithType('danger', 'Некорректный формат числа')
          }
        } else {
          this.openNotificationWithType('danger', 'Необходимо выбрать дату')
        }
      } else {
        this.openNotificationWithType('danger', 'Сначала необходимо сохранить логин и пароль')
      }
    },
    getBalance() {
      this.$http.get(BILLING_API + '/balance/' + this.profile.client, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.balance = response.data
        })
    },
    getSumPayment() {
      this.$http.get(BILLING_API + '/sumpayment/' + this.profile.client, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.sumPay = response.data
        })
    },
    getSumConsume() {
      this.$http.get(BILLING_API + '/sumconsume/' + this.profile.client, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.sumConsume = response.data
        })
    },
    makePayment() {
      if (this.regSum.test(this.sumPayment)) {
        if (this.sumPayment > 0) {
          this.$http.post(PAYMENTS_API + '/yandex', this.preparePaymentParameters(this.loggedId, this.sumPayment),
            {headers: this.prepareSecurityHeader()})
            .then((response) => {
              console.log(response)
              console.log(response.data)
              window.location.href = response.data
            })
            .catch((error) => {
              console.log(error)
              this.openNotificationWithType('danger', 'Ошибка платежа. ')
            })
        } else {
          this.openNotificationWithType('danger', 'Укажите сумму больше нуля')
        }
      } else {
        this.openNotificationWithType('danger', 'Некорректный формат числа')
      }
    },
    preparePaymentParameters (id, sum) {
      const paymentFormData = new FormData()
      const currentUrl = window.location
      paymentFormData.append('id', id)
      paymentFormData.append('sum', sum)
      paymentFormData.append('returnUrl', currentUrl)
      return paymentFormData
    },
    sortedBilling() {
      return this.billings.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      }).filter((row, index) => {
        let start = (this.currentPage - 1) * this.perPage
        let end = this.currentPage * this.perPage
        if (index >= start && index < end) return true
      })
    },
    sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
      this.sortedBillings = this.sortedBilling()
    },
    sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon
        } else {
          return this.descIcon
        }
      } else {
        return ''
      }
    },
    onClickFirstPage() {
      this.onPageChange(1)
    },
    onClickPreviousPage() {
      this.onPageChange(this.currentPage - 1)
    },
    onClickPage(page) {
      this.onPageChange(page)
    },
    onClickNextPage() {
      this.onPageChange(this.currentPage + 1)
    },
    onClickLastPage() {
      this.onPageChange(this.totalPages)
    },
    isPageActive(page) {
      return this.currentPage === page
    },
    onPageChange(page) {
      this.currentPage = page
      this.sortedBillings = this.sortedBilling()
    },
    openNotificationWithType (type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      })
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../../node_modules/bulma/sass/utilities/mixins';

.time {
  margin: 0px 10px;
}

</style>



// WEBPACK FOOTER //
// User.vue?b3a191a2